export default __webpack_public_path__ + "static/dark-mobile-sg-f20ffea047a330eb2f97b017003385a6.svg";